import apiFetch from "@wordpress/api-fetch";

const path = "/corksy/v1/settings";

class SettingsService {
	async get() {
		const settings = await apiFetch({ path });
		return settings.length ? settings[0] : {};
	}

	async save(settings) {
		const response = await apiFetch({
			path,
			method: "POST",
			data: settings,
		});
		return response;
	}
}

export default new SettingsService();
